import React from 'react'

import Icon from 'components_new/atoms/Icon'
import Switch from 'components_new/atoms/Switch'

import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'

import { useTranslation } from 'language/translator'

interface OtherProps {
  hideFooter: boolean
  setHideFooter: (value: boolean) => void
}

const Other = (props: OtherProps) => {
  const { hideFooter, setHideFooter } = props

  const { t } = useTranslation()

  return (
    <SettingsGroup title={t('global', 'misc_label')}>
      <SettingsItem
        actions={
          <Switch
            color="success"
            checked={hideFooter}
            onChange={() => setHideFooter(!hideFooter)}
            size="medium"
          />
        }
        body={t('dashboards', 'hide_footer_description')}
        icon={<Icon name={'BorderBottomOutlined'} />}
        title={t('dashboards', 'hide_footer_label')}
        titleAdornments={<code>?hide_footer=true</code>}
      />
    </SettingsGroup>
  )
}

export default Other
